import type {RefObject} from 'react';
import {useEffect, useLayoutEffect, useMemo, useState} from 'react';
import type {GraphicsMetaMapType} from '@Components/social-media/publish-params.types';
import type {GraphicsChangeDependencies} from './social-post-content-multiposting.types';

export function useIsElementContentClamped(elementRef: RefObject<HTMLElement | null>, content: string): boolean {
  const [isClamped, setIsClamped] = useState(false);

  useLayoutEffect((): VoidFunction | undefined => {
    const element = elementRef.current;

    if (!element) {
      return undefined;
    }

    const measureClamping = (): void => {
      setIsClamped(element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth);
    };

    measureClamping();

    const elementResizeObserver = new ResizeObserver(measureClamping);
    elementResizeObserver.observe(element);

    return (): void => {
      elementResizeObserver.disconnect();
    };
  }, [content]);

  return isClamped;
}

export function useGraphicsSignature(designsGraphicMetaMap: GraphicsMetaMapType): string {
  return useMemo(() => JSON.stringify(designsGraphicMetaMap), [designsGraphicMetaMap]);
}

export function useResetLoadingOnGraphicsChange(dependencies: GraphicsChangeDependencies, resetLoading: VoidFunction): void {
  useEffect((): void => {
    resetLoading();
  }, [dependencies.accountId, dependencies.platformMediaType, dependencies.graphicsSignature]);
}
